import { render } from "./HeroiconsOutlineCurrencyDollar.vue?vue&type=template&id=d21a424a"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyDollar.vue"]])

export default __exports__